// src/layouts/Root.jsx
import React from "react";
import TopNavLayout from "../components/Sidebar";
import SubscriptionGate from "../components/SubscriptionGate";

const Root = ({ children }) => {
  return (
    <>
      <TopNavLayout>
        <SubscriptionGate>{children}</SubscriptionGate>
      </TopNavLayout>
    </>
  );
};

export default Root;
